// Generated by ReScript, PLEASE EDIT WITH CARE


var fetchPlaceIdError = "Error on fetching updated place id";

var googleGeoCodeError = "Error on google geo code custom with retry";

export {
  fetchPlaceIdError ,
  googleGeoCodeError ,
}
/* No side effect */
